import axios from 'axios';

export const $api = axios.create({});

$api.interceptors.request.use(
    (config) => {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export { queueableApi } from './queueable';
